import type { LogoComponent } from '@iheartjane/reefer';
import {
  GovernmentIcon,
  BoaLogo,
  CapitalOneLogo,
  ChaseLogo,
  CitiLogo,
  PncLogo,
  UsaaLogo,
  WfLogo,
} from '@iheartjane/reefer';
import { clsx } from 'clsx';

import styles from './bankIcon.module.css';

const BANK_NAMES_MAP: { [key: string]: LogoComponent } = {
  'Bank of America': BoaLogo,
  'Capital One': CapitalOneLogo,
  Chase: ChaseLogo,
  Citibank: CitiLogo,
  'PNC Bank, N.A.': PncLogo,
  USAA: UsaaLogo,
  'Wells Fargo Bank': WfLogo,
};

export const BankCircledIcon = ({ name }: { name: string }) => {
  const Logo = BANK_NAMES_MAP[name] || GovernmentIcon;
  const hasLogo = !!BANK_NAMES_MAP[name];

  return (
    <div
      className={clsx(
        styles['container'],
        hasLogo && styles['containerWithLogo']
      )}
    >
      <Logo height="auto" width="auto" altText={`${name}-icon`} />
    </div>
  );
};
